import React, {useEffect, useMemo, useState} from 'react';
import {Box, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles} from '@material-ui/core';
import {IconClose} from '../../../components/Icons';
import {rieltor} from '../../../styles/theme';
import Typo from '../../../components/Typo';
import {FormattedMessage} from 'react-intl';
import {ButtonPurple} from '../../../components/Buttons';
import RouterLink from '../../common/RouterLink';
import {LocalStorageKeys, RoleId} from '../../../common/types';
import {useCurrentUser} from '../../../hooks/user';
import {createProfileEditUrl} from '../../../utils/navigation';
import {useLocalStorage} from '@rehooks/local-storage';
import {isSameHour} from 'date-fns';
import {IsAlertVisible} from '../../../utils';
import {fetchUserInfo} from '../../../store/user/actions';
import {setLocalItem} from '../../../store/local/reducer';
import {UsersAPI} from '../../../services/UsersAPI';
import {useDispatch} from 'react-redux';
const ALERT_ID_FORCE_AVATAR = '401';

const useStyles = makeStyles((theme) => ({
  popupWrapper: {
    '& .MuiDialog-paper': {
      maxWidth: '650px !important',
    },
    '& .MuiDialogContent-root': {
      padding: '8px 30px',
    },
  },
}));
const ForceAvatarAlert = () => {
  const classes = useStyles();

  const user = useCurrentUser();
  const [open, setOpen] = useState(false);
  const usersAPI = useMemo(() => new UsersAPI(), []);
  const dispatch = useDispatch();

  const isAlertVisible = IsAlertVisible(user, ALERT_ID_FORCE_AVATAR, usersAPI);

  useEffect(() => {
    if(!isAlertVisible) {
      return;
    }
    if (user && !user.avatar && (user.roleId === RoleId.Realtor)) {
      setOpen(true);
      try {
        usersAPI.updateAlertStatus({id: ALERT_ID_FORCE_AVATAR, firstView: true});
        dispatch(fetchUserInfo());
        dispatch(setLocalItem(LocalStorageKeys.ForceAvatarAlert, true));
      } catch (e) {
      }
    }
  }, [isAlertVisible]);

  if (user === null) {
    return null;
  }

  return (
      <Dialog
          className={classes.popupWrapper}
          open={open}
      >
        <DialogTitle style={{padding: '8px 16px'}}>
          <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <div>&nbsp;</div>
          </Box>
        </DialogTitle>

        <DialogContent>
          <div>
            <Typo variant={'title0'}>
              <FormattedMessage id={'alerts.force_avatar_alert.title'}/>
            </Typo>
          </div>

          <p style={{margin: '30px 0', lineHeight: '28px', fontFamily: rieltor.fontFamily, fontSize: '16px'}}>
            <FormattedMessage id={'alerts.force_avatar_alert.text_alter'}/>
          </p>
        </DialogContent>

        <DialogActions style={{justifyContent: 'center', padding: '0 16px 20px 16px'}}>
          <ButtonPurple
              // @ts-ignore
              component={RouterLink}
              to={createProfileEditUrl({}) + '#profile_edit_info'}
          >
            <FormattedMessage id={'alerts.force_avatar_alert.button'}/>
          </ButtonPurple>
        </DialogActions>
      </Dialog>
  );
};

export default ForceAvatarAlert;
